import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_mst_ecomsync_item_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  fi_item_line_guid: fromDatatype.GuidDataFieldInterface;
  ecomsync_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  mkt_guid: fromDatatype.GuidDataFieldInterface;
  mkt_item_id: fromDatatype.VarcharDatatypeInterface;
  mkt_item_name: fromDatatype.VarcharDatatypeInterface;
  mkt_item_status: fromDatatype.StatusDataFieldInterface;
  mkt_category: fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  mkt_type: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  attributes?: {};
  descr: fromDatatype.TextDatatypeInterface;
  uom: fromDatatype.VarcharDatatypeInterface;
  amount: fromDatatype.NumericDatatypeInterface;
  quantity: fromDatatype.NumericDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  ccy_code:  fromDatatype.VarcharDatatypeInterface;
  ccy_xrate: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  logic: fromDatatype.VarcharDatatypeInterface;
  price_json: fromDatatype.JsonDatatypeInterface;
  options_json: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  dim_width: fromDatatype.NumericDatatypeInterface;
  dim_height: fromDatatype.NumericDatatypeInterface;
  dim_length: fromDatatype.NumericDatatypeInterface;
  dim_weight: fromDatatype.NumericDatatypeInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_source: fromDatatype.VarcharDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  mkt_seller_sku: fromDatatype.VarcharDatatypeInterface;
  mkt_shop_sku: fromDatatype.VarcharDatatypeInterface;
  branch_list: fromDatatype.JsonDatatypeInterface;
  sales_order_list: fromDatatype.JsonDatatypeInterface;
  mode_config: fromDatatype.VarcharDatatypeInterface;
  sales_order_config: fromDatatype.VarcharDatatypeInterface;
  qty_balance: fromDatatype.NumericDatatypeInterface;
  buffer_config: fromDatatype.VarcharDatatypeInterface;
  qty_buffer: fromDatatype.NumericDatatypeInterface;
  mkp_seller_stock_bal_qty : fromDatatype.NumericDatatypeInterface;
  mkp_seller_available_qty : fromDatatype.NumericDatatypeInterface;
  mkp_seller_buffer : fromDatatype.NumericDatatypeInterface;
  mkp_open_seller_order_qty: fromDatatype.NumericDatatypeInterface;
  percentage: fromDatatype.NumericDatatypeInterface;
  mkt_sku_id: fromDatatype.VarcharDatatypeInterface;
  pricing_scheme_overwrite: fromDatatype.VarcharDatatypeInterface;
  pricing_scheme: fromDatatype.GuidDataFieldInterface;
  pricing_scheme_item_link_guid: fromDatatype.GuidDataFieldInterface;
  override_branch_stock_config: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_mst_ecomsync_item_line_RowClass
  implements bl_fi_mst_ecomsync_item_line_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
  fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  fi_item_line_guid: fromDatatype.GuidDataFieldInterface;
  ecomsync_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  mkt_guid: fromDatatype.GuidDataFieldInterface;
  mkt_item_id: fromDatatype.VarcharDatatypeInterface;
  mkt_item_name: fromDatatype.VarcharDatatypeInterface;
  mkt_item_status: fromDatatype.StatusDataFieldInterface;
  mkt_category: fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  mkt_type: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  attributes?: {};
  descr: fromDatatype.TextDatatypeInterface;
  uom: fromDatatype.VarcharDatatypeInterface;
  amount: fromDatatype.NumericDatatypeInterface;
  quantity: fromDatatype.NumericDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  ccy_code:  fromDatatype.VarcharDatatypeInterface;
  ccy_xrate: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  logic: fromDatatype.VarcharDatatypeInterface;
  price_json: fromDatatype.JsonDatatypeInterface;
  options_json: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  dim_width: fromDatatype.NumericDatatypeInterface;
  dim_height: fromDatatype.NumericDatatypeInterface;
  dim_length: fromDatatype.NumericDatatypeInterface;
  dim_weight: fromDatatype.NumericDatatypeInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_source: fromDatatype.VarcharDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  mkt_seller_sku: fromDatatype.VarcharDatatypeInterface;
  mkt_shop_sku: fromDatatype.VarcharDatatypeInterface;
  branch_list: fromDatatype.JsonDatatypeInterface;
  sales_order_list: fromDatatype.JsonDatatypeInterface;
  mode_config: fromDatatype.VarcharDatatypeInterface;
  sales_order_config: fromDatatype.VarcharDatatypeInterface;
  qty_balance: fromDatatype.NumericDatatypeInterface;
  buffer_config: fromDatatype.VarcharDatatypeInterface;
  qty_buffer: fromDatatype.NumericDatatypeInterface;
  mkp_seller_stock_bal_qty : fromDatatype.NumericDatatypeInterface;
  mkp_seller_available_qty : fromDatatype.NumericDatatypeInterface;
  mkp_seller_buffer : fromDatatype.NumericDatatypeInterface;
  mkp_open_seller_order_qty: fromDatatype.NumericDatatypeInterface;
  percentage: fromDatatype.NumericDatatypeInterface;
  mkt_sku_id: fromDatatype.VarcharDatatypeInterface;
  pricing_scheme_overwrite: fromDatatype.VarcharDatatypeInterface;
  pricing_scheme: fromDatatype.GuidDataFieldInterface;
  pricing_scheme_item_link_guid: fromDatatype.GuidDataFieldInterface;
  override_branch_stock_config: fromDatatype.VarcharDatatypeInterface;
}
